import * as React from 'react';

import {Icon} from '.';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const RetryUpload: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path
        fill={props?.fill || '#5DA9E9'}
        d="M11.56 3.969a4.968 4.968 0 0 0-4.05-1.444c-2.295.231-4.182 2.094-4.438 4.388a4.99 4.99 0 0 0 9.462 2.737.626.626 0 0 0-1.112-.569 3.746 3.746 0 0 1-4.25 2.07 3.717 3.717 0 0 1-2.8-2.826A3.751 3.751 0 0 1 8.028 3.75c1.037 0 1.962.431 2.637 1.113l-.943.943c-.394.394-.12 1.069.437 1.069h2.244a.627.627 0 0 0 .625-.625V4.006a.627.627 0 0 0-1.069-.443l-.4.406Z"
      />
    </Icon>
  );
};

export default React.memo(RetryUpload);
